import { botClassIcons, botConcernIcons, botSynergyIcon } from "utils/bot/icons"

import type { Bot } from "types/bot"
import type { EntityStats } from "types/entity"

const botSynergyLabels = {
  faraday: "Bio-tech",
  hyperion: "Invader",
  tormund: "Magnetic",
}

export const getMainInfo = (bot?: Bot) => {
  const BotClassIcon = (bot?.class && botClassIcons[bot.class]) || undefined
  const BotConcernIcon = (bot?.corporation && botConcernIcons[bot.corporation]) || undefined
  const aerialProducer =
    bot?.synergy && bot?.attributes.find(attr => attr.type === "dominant" && attr.slot === "aerial")?.producer

  const BotSynergyIcon = (aerialProducer && botSynergyIcon[aerialProducer]) || undefined
  const botSynergyLabel = (aerialProducer && botSynergyLabels[aerialProducer]) || undefined

  const synergyProp = BotSynergyIcon && bot?.synergy ? { icon: BotSynergyIcon } : { value: "-" }

  return [
    {
      label: bot?.class || "",
      icon: BotClassIcon,
    },
    {
      label: bot?.corporation || "",
      icon: BotConcernIcon,
    },
    {
      label: "Power",
      value: Math.floor(bot?.power || 1),
    },
    {
      label: botSynergyLabel || "Synergy",
      ...synergyProp,
    },
  ]
}

export const getMainStats = (health: number, damage: number, armor: number, speed: number) => [
  {
    label: "Health",
    value: health,
    imgUrl: "/images/common/stats/health_icon.png",
  },
  {
    label: "Damage",
    value: damage,
    imgUrl: "/images/common/stats/damage_icon.png",
  },
  {
    label: "Armor",
    value: armor,
    imgUrl: "/images/common/stats/armor_icon.png",
  },
  {
    label: "Speed",
    value: speed,
    imgUrl: "/images/common/stats/speed_icon.png",
  },
]

export const getSecondaryStats = ({
  block_amount,
  block_chance,
  crit_amount,
  crit_chance,
  dodge_chance,
  focus,
  resistance,
  accuracy,
}: EntityStats) => [
  {
    label: "Focus",
    value: focus,
  },
  {
    label: "Resistance",
    value: resistance,
  },
  {
    label: "Crit damage",
    value: crit_amount,
  },
  {
    label: "Crit chance",
    value: crit_chance,
  },
  {
    label: "Dodge chance",
    value: dodge_chance,
  },
  {
    label: "Block chance",
    value: block_chance,
  },
  {
    label: "Block amount",
    value: block_amount,
  },
  {
    label: "Accuracy",
    value: accuracy || 0,
  },
]

export const getIsNew = (bot: Bot) => {
  const dna = Number(bot.dna)
  return !dna
}

export const getGenerationText = (generation = 0) => {
  return generation === 0 ? "[genesis]" : "" //@todo map?
}
